import React from "react";

import loadingIndicator from "@assets/sales-v3-chart-loading.gif";

import { useCustomMetrics } from "./hooks/use-custom-metrics";

type Props = {
  children: React.ReactNode;
};

const getLoadingText = (loadingState: Record<string, boolean>) => {
  if (loadingState.isMetricsLoading) {
    return "Loading...";
  } else if (loadingState.isCreateMetricLoading) {
    return "Creating...";
  } else if (loadingState.isUpdateMetricLoading) {
    return "Updating...";
  } else if (loadingState.isDeleteMetricLoading) {
    return "Deleting...";
  }
  return "";
};

export const CustomMetricsLoading = ({ children }: Props) => {
  const { isLoading, loadingState } = useCustomMetrics();

  if (!isLoading) {
    return <>{children}</>;
  }

  return (
    <div
      className="flex-center"
      style={{ gridColumn: "2 / span 3", gridRow: "1 / span 3" }}
    >
      <div className="h-2/3">
        <img
          src={loadingIndicator}
          alt="Loading metrics"
          className="h-full w-full"
        />
        <div className="text-center font-semibold text-2xl text-gray">
          {getLoadingText(loadingState)}
        </div>
      </div>
    </div>
  );
};
